require("./chart");
require("./graphUtils");
//        var $controller = $self.attr('data-controller')
//                    ? $self
//                    : $self.closest('[data-controller]');

function isInSummaryChartPage() {
  return $("#summary-chart").length > 0;
}

if (isInSummaryChartPage()) {
  var instanceArray = [];

  var recordLevel = false;


  $(".data-grid").hide();
  $("#downloadButton").click(function () {
    downloadCall($("form").serialize());
  });

  $("#summaryButton").click(function () {
    downloadStats($("form").serialize());
  });

  $("#dateFrom").on("change", function () {
    getInstances($("form").serialize());
  });

  $("#dateTo").on("change", function () {
    getInstances($("form").serialize());
  });
  $(".remove-selected-facet").click(function () {
    getInstances($("form").serialize());
  });

  $("#recordLevel").click(function () {
    recordLevel = true;
  });

  $("#summaryLevel").click(function () {
    recordLevel = false;
  });

  $(".js-active-filters-clear").click(function () {
    recordLevel = false;
    $("#summaryLevel").closest("label").addClass("focused selected");
    $("#filterBox li").last().remove();
    $("#filterBox li").first().find("a").attr("hidden", "hidden");
  });

  $("#filterBox").on("DOMSubtreeModified", function (event) {
    $("#filterBox")
      .find('[data-facet-id="summaryLevel"]')
      .find("a")
      .attr("hidden", "hidden");
  });
}

function downloadCall(formData) {
  $.ajax({
    type: "GET",
    dataType: "JSON",
    url: "/submissions/submissions-dashboard/summary-download",
    //            data: $("#transactionsReportCommand").serialize()
  })
    .done(function (response) {
      redirectTo("/submissions/submissions-dashboard/download?" + formData);
      //                return response;
    })
    .fail(function (response) {
    });
}

function downloadStats(formData) {
  $.ajax({
    type: "GET",
    dataType: "JSON",
    url: "/submissions/submissions-dashboard/summary-download",
    //            data: $("#transactionsReportCommand").serialize()
  })
    .done(function (response) {
      redirectTo("/submissions/dashboard/stats?" + formData);
      //                return response;
    })
    .fail(function (response) {
    });
}

function getInstances(quarter) {
  var ajaxResponse;
  $.ajax({
    type: "GET",
    dataType: "JSON",
    url: "/submissions/dashboard/getInstances?" + quarter,
    //            data: $("#transactionsReportCommand").serialize()
  })
    .done(function (response) {

      setCollectionInstances(response);
    })
    .fail(function (response) {
      var json = {
        estimate: 21,
        "instance-id-values": [
          "cascade-data-inst-cas",
          "datastore-limit-instance-datastore",
          "del-398-01",
          "hello-test-hello-instance",
          "nit-hclic-insta-hclic",
          "nit-notsure1-test-notsure",
          "orb-err-warn-inst-orb-warn",
          "test-24-july-01-02",
          "test-25-july-01",
          "test-25-july-02-25-02",
          "test-dataset-test-instance",
          "test-del-691-inst-del-691",
          "test-ext-1-inst-ext-1",
          "test-ext-1-inst-ext-2",
          "test-new-insta1",
          "test-nit1-test-instance-nit1",
          "test-nit1-test-instance-nit2",
          "test-orb-error-ins-01",
          "test-trans1-insta-trans1",
          "tr-dat1-inst-tr-01",
          "tr-dat3-tr-dat3-insta3",
        ],
      };
    });
}

function redirectTo(u) {
  window.location.href = u;
}

function setCollectionInstances(response) {
  var responseArray = [];

  if (response != undefined) {
    responseArray = response["instance-id-values"];
    $("#instanceName").empty();
    $("#instanceName").trigger("chosen:updated");
    if (typeof responseArray == "string") {
      $("#instanceName").append(
        '<option value="' + responseArray + '">' + responseArray + "</option>",
      );
    } else {
      if (responseArray != null) {
        var arrayLength = responseArray.length;
        for (var i = 0; i < arrayLength; i++) {
          $("#instanceName").append(
            '<option value="' +
              responseArray[i] +
              '">' +
              responseArray[i] +
              "</option>",
          );
          $("#instanceName").trigger("chosen:updated");
        }
      }
    }
    $("#instanceName").trigger("chosen:updated");
  }
}

module.exports = {
  displayChart: function (response) {
    //    function displayChart(response){

    var sampleResponse = {
      "submissions-summary": {
        "dataset-id": ["pool-2019-20"],
        "instance-id": ["pool-2019-20-q2", "pool-2019-20-q3"],
        "collection-status": "live",
        stats: {
          "expected-count": "1500",
          "instance-count": "20",
          "submitted-count": "300",
          "saved-count": "500",
          "certified-count": "350",
          "outstanding-count": "1400",
          "ready-to-certify-count": "900",
        },
      },
    };

    var instanceCount;
    var submittedMap;
    var submittedPercentage;

    var savedMap;
    var savedPercentage;

    var expectedMap;
    var expectedPercentage;

    var certifiedMap;
    var certifiedPercentage;

    var outstandingMap;
    var outstandingPercentage;

    var readyToCertifyMap;
    var readyToCertifyPercentage;

    var labelArray;
    var dataArray;
    var barColorArray;

    var jsonArray = response["submissions-summary"]["stats"];
    var totalSum;
    //        var jsonArray = sampleResponse["submissions-summary"]["stats"];
    instanceCount = jsonArray["instance-count"];
    if (recordLevel != true) {
      labelArray = [
        "Outstanding",
        "Saved",
        "Submitted",
        "Ready to certify",
        "Certified",
      ];
      $("#certified").removeAttr("hidden");
      $("#outstanding").removeAttr("hidden");
      $("#expected").removeAttr("hidden");
      $("#totalRecords").attr("hidden", "hidden");
      submittedMap = jsonArray["submitted-count"];
      //        submittedMap = 129;
      savedMap = jsonArray["saved-count"];
      //        savedMap = 8;
      expectedMap = jsonArray["expected-count"];
      //        expectedMap = 1503;
      certifiedMap = jsonArray["certified-count"];
      //        certifiedMap = 137;
      outstandingMap = jsonArray["outstanding-count"];
      //        outstandingMap = 1229;
      readyToCertifyMap = jsonArray["ready-to-certify-count"];

      dataArray = [
        outstandingMap,
        savedMap,
        submittedMap,
        readyToCertifyMap,
        certifiedMap,
      ];
      barColorArray = [
        window.chartColors.orange,
        window.chartColors.yellow,
        window.chartColors.blueVarient,
        window.chartColors.purple,
        window.chartColors.green,
      ];

      $("#liveRecords").text(" " + thousandSeperatedValues(instanceCount));
      $("#savedReturns").text(" " + thousandSeperatedValues(savedMap));
      $("#submittedReturns").text(" " + thousandSeperatedValues(submittedMap));
      $("#certifiedReturns").text(" " + thousandSeperatedValues(certifiedMap));
      $("#outstandingReturns").text(
        " " + thousandSeperatedValues(outstandingMap),
      );
      $("#readyToCertifyReturns").text(
        " " + thousandSeperatedValues(readyToCertifyMap),
      );
      $("#totalCollections").text(" " + thousandSeperatedValues(expectedMap));

      outstandingPercentage = getPercentage(outstandingMap, expectedMap);
      $("#outstandingPercentage").text(outstandingPercentage + "%");

      savedPercentage = getPercentage(savedMap, expectedMap);
      $("#savedPercentage").text(savedPercentage + "%");

      submittedPercentage = getPercentage(submittedMap, expectedMap);
      $("#submittedPercentage").text(submittedPercentage + "%");

      certifiedPercentage = getPercentage(certifiedMap, expectedMap);
      $("#certifiedPercentage").text(certifiedPercentage + "%");

      readyToCertifyPercentage = getPercentage(readyToCertifyMap, expectedMap);
      $("#readyToCertifyPercentage").text(readyToCertifyPercentage + "%");
    } else {
      labelArray = ["Saved", "Submitted", "Ready to certify"];
      submittedMap = jsonArray["records-submitted"];
      readyToCertifyMap = jsonArray["records-ready-to-certify"];
      $("#totalRecords").removeAttr("hidden");
      //        submittedMap = 129;
      savedMap = jsonArray["records-saved"];
      totalSum = submittedMap + savedMap + readyToCertifyMap;
      //        savedMap = 8;
      expectedMap = 0;
      //        expectedMap = 1503;
      certifiedMap = 0;
      //        certifiedMap = 137;
      outstandingMap = 0;
      //        outstandingMap = 1229;
      dataArray = [savedMap, submittedMap, readyToCertifyMap];
      barColorArray = [
        window.chartColors.yellow,
        window.chartColors.blueVarient,
        window.chartColors.purple,
      ];

      $("#liveRecords").text(" " + thousandSeperatedValues(instanceCount));
      $("#savedReturns").text(" " + thousandSeperatedValues(savedMap));
      $("#submittedReturns").text(" " + thousandSeperatedValues(submittedMap));
      $("#readyToCertifyReturns").text(
        " " + thousandSeperatedValues(readyToCertifyMap),
      );
      $("#totalSum").text(thousandSeperatedValues(totalSum));
      $("#certified").attr("hidden", "hidden");
      $("#outstanding").attr("hidden", "hidden");
      $("#expected").attr("hidden", "hidden");

      savedPercentage = getPercentage(savedMap, totalSum);
      $("#savedPercentage").text(savedPercentage + "%");

      submittedPercentage = getPercentage(submittedMap, totalSum);
      $("#submittedPercentage").text(submittedPercentage + "%");

      readyToCertifyPercentage = getPercentage(readyToCertifyMap, totalSum);
      $("#readyToCertifyPercentage").text(readyToCertifyPercentage + "%");
    }

    Chart.defaults.scale.ticks.beginAtZero = true;
    var barChartData = {
      labels: labelArray,
      datasets: [
        {
          data: dataArray,
          backgroundColor: barColorArray,
        },
      ],
    };

    var ctx = document.getElementById("barChart").getContext("2d");
    if (window.myBar != undefined) {
      window.myBar.destroy();
    }

    window.myBar = new Chart(ctx, {
      type: "bar",
      data: barChartData,
      options: {
        title: {
          display: true,
          text: "Submissions summary",
        },
        legend: {
          labels: {
            filter: function (legendItem, chartData) {
              return false;
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  if (parseInt(value) >= 1000 || parseInt(value) >= 1000) {
                    return value / 1000 + "K";
                  } else {
                    if (Math.floor(value) === value) {
                      return value;
                    }
                  }
                },
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              //get the concerned dataset
              var dataset = data.datasets[tooltipItem.datasetIndex];
              //calculate the total of this data set
              var total = expectedMap;
              //get the current items value
              var currentValue = dataset.data[tooltipItem.index];
              var newValue = currentValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
              var percentage;
              if (recordLevel == true) {
                percentage = Math.floor((currentValue / totalSum) * 100 + 0.5);
              } else {
                percentage = Math.floor((currentValue / total) * 100 + 0.5);
              }

              return "Percentage:" + percentage + "% | Count:" + newValue;
            },
          },
        },
      },
    });
  },
};

function thousandSeperatedValues(currentValue) {
  return currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getPercentage(value, expectedValue) {
  if (value == 0 || expectedValue == 0) {
    return 0;
  } else {
    return ((value / expectedValue) * 100).toFixed(2);
  }
}
